import React from 'react';
import Media from 'react-media';

import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';

import { ScreenBreakpoints } from 'app/src/components/Responsive';
import SearchForm from 'app/gamma/src/components/search/form';
import printStyles from 'app/gamma/src/components/shared/print.less';

import { RouteContextProvider } from 'app/common/components/RouteContextProvider/RouteContextProvider';
import { RouteNames } from 'app/common/router';
import BackToHomeLink from 'app/gamma/src/components/header/back-to-home-link';
import DesktopSettingsButton from 'app/gamma/src/components/header/desktop-settings-button';
import NotificationsMenuButton from 'app/gamma/src/components/header/notifications-menu-button';
import HeaderBoardMenuButton from './board-menu-button';
import ChannelSwitcherButton from './channel-switcher-button';
import { CreateMenuButton } from './create-menu-button';
import EnterpriseMenuButton from './enterprise-menu-button';
import HeaderLogo from './header-logo';
import { InfoMenuButton } from './info-menu-button';
import MemberMenuButton from './member-menu-button';
import { TacoAnnouncements } from 'app/src/components/TacoAnnouncements';

import { MemberModel } from 'app/gamma/src/types/models';

import styles from './header.less';
import { isDesktop } from '@trello/browser';
import { AtlassianAppSwitcherButton } from 'app/gamma/src/components/header/atlassian-app-switcher-button';

interface AuthenticatedHeaderProps {
  alwaysOpenBoardsMenu: boolean;
  brandingColor: string | undefined;
  member: MemberModel | undefined;
}

export const AuthenticatedHeader: React.FunctionComponent<AuthenticatedHeaderProps> = ({
  member,
  alwaysOpenBoardsMenu,
  brandingColor,
}) => (
  <RouteContextProvider>
    {({ routeName }) => (
      <div
        id="header"
        className={classNames(
          styles.header,
          routeName !== RouteNames.BOARD &&
            routeName !== RouteNames.CARD &&
            styles.default,
          printStyles.noPrint,
        )}
        data-test-id={HeaderTestIds.Container}
        style={{ backgroundColor: brandingColor }}
      >
        <div className={styles.leftSection}>
          <BackToHomeLink />
          {!alwaysOpenBoardsMenu && <HeaderBoardMenuButton />}
          {routeName !== RouteNames.SEARCH && <SearchForm />}
          <TacoAnnouncements />
        </div>
        <HeaderLogo />
        <div className={styles.rightSection}>
          <CreateMenuButton />
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) =>
              matches &&
              !isDesktop() && (
                <div className={styles.flexContainer}>
                  <InfoMenuButton />
                </div>
              )
            }
          </Media>
          <NotificationsMenuButton />
          <EnterpriseMenuButton />
          <AtlassianAppSwitcherButton member={member} />
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) =>
              matches && (
                <div className={styles.flexContainer}>
                  <ChannelSwitcherButton />
                </div>
              )
            }
          </Media>
          <MemberMenuButton />
          {isDesktop() && <DesktopSettingsButton />}
        </div>
      </div>
    )}
  </RouteContextProvider>
);
